import styled from 'styled-components'

export const AccessBlock = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  height: 48px;
  @media (max-width: 576px) {
    margin-top: 15px;
    justify-content: center;
  }
`

export const TrackImg = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
`
export const TrackText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
`

export const TrackTitle = styled.div`
  color: #646877;
  font-weight: 600;
  font-size: 14px;
  line-height: 21px;
  @media (min-width: 576px) {
    margin-bottom: 4px;
  }
`
export const TrackDescription = styled.div`
  font-weight: 400;
  line-height: 21px;
  color: #646877;
`

export const TrackContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 576px) {
    flex-direction: column;
    align-items: start;
    gap: 26px;
    button {
      align-self: center;
    }
  }
`

export const TrackBlock = styled.div`
  min-height: 48px;
  display: flex;
  gap: 16px;
  align-items: center;
`
